import React from 'react';

const GuestTrustModel = () => (
  <section className="py-24 bg-[#919191]/5">
    <div className="max-w-screen-2xl mx-auto px-10">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">

        {/* Left — Shield illustration card */}
        <div className="bg-[#0077b5]/10 flex items-center justify-center p-16 min-h-[360px] relative overflow-visible">
          {/* Outer dashed ring */}
          <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
            <div
              className="rounded-full border-2 border-dashed border-[#0077b5]/30"
              style={{ width: '78%', height: '78%' }}
            ></div>
          </div>
          {/* Corner dots */}
          <span className="absolute top-[13%] left-[13%] w-3 h-3 rounded-full bg-[#0077b5]"></span>
          <span className="absolute top-[13%] right-[13%] w-3 h-3 rounded-full bg-[#0077b5]"></span>
          <span className="absolute bottom-[13%] left-[13%] w-3 h-3 rounded-full bg-[#0077b5]"></span>
          <span className="absolute bottom-[13%] right-[13%] w-3 h-3 rounded-full bg-[#0077b5]"></span>

          {/* Shield SVG */}
          <div className="relative z-10">
            <svg width="160" height="180" viewBox="0 0 160 180" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M80 8L16 34V90C16 128 44 162 80 172C116 162 144 128 144 90V34L80 8Z" fill="#0077b5" />
              <path d="M80 28L34 48V90C34 118 54 143 80 152C106 143 126 118 126 90V48L80 28Z" fill="#005f8e" />
              <path d="M56 91L72 107L104 72" stroke="white" strokeWidth="9" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
        </div>

        {/* Right — Text content */}
        <div>
          <div className="inline-block border border-[#919191] text-[#919191] text-xs font-semibold tracking-widest uppercase px-4 py-1.5 rounded-full mb-6">
            Who We Are
          </div>
          <h2 className="text-4xl font-extrabold text-[#53545a] leading-tight mb-6">
            Built to be the trust layer<br />your customers rely on
          </h2>
          <p className="text-[#919191] text-base leading-relaxed mb-5">
            My Risk Shield is a managed trust center platform designed for organizations that want to communicate their security and compliance posture clearly — without the overhead of managing it themselves.
          </p>
          <p className="text-[#919191] text-base leading-relaxed">
            We sit between you and your customers, answering their questions, managing their requests, and providing verifiable evidence that you're a trustworthy partner. Think of us as your dedicated compliance concierge.
          </p>
        </div>

      </div>
    </div>
  </section>
);

export default GuestTrustModel;
